import { render, staticRenderFns } from "./PcParserNew.vue?vue&type=template&id=97ad544e&scoped=true"
import script from "./PcParserNew.vue?vue&type=script&lang=js"
export * from "./PcParserNew.vue?vue&type=script&lang=js"
import style0 from "./PcParserNew.vue?vue&type=style&index=0&id=97ad544e&prod&lang=css"
import style1 from "./PcParserNew.vue?vue&type=style&index=1&id=97ad544e&prod&lang=less&scoped=true"
import style2 from "./PcParserNew.vue?vue&type=style&index=2&id=97ad544e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97ad544e",
  null
  
)

export default component.exports